import {
  GET_SPACE_DETAIL_REQUEST,
  GET_SPACE_DETAIL_SUCCESS,
  GET_SPACE_DETAIL_FAILURE,
} from "../actions/spacesActions.js";

const INITIAL_STATE = {
  data: null,
  isFetching: false,
  error: false,
};

const spaceDetailReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SPACE_DETAIL_REQUEST:
      return {
        ...state,
        data: null,
        isFetching: true,
        error: false,
      };
    case GET_SPACE_DETAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.payload.spaceId,
      };
    case GET_SPACE_DETAIL_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: true,
      };

    default:
      return state;
  }
};

export default spaceDetailReducer;
